import { IFinanceDocuments } from '../../../types';
export type IFinanceDocumentState = IFinanceDocuments;

export enum DocActionTypes {
  TOGGLE_REQUIRED_DOCUMENTS = '@@student/finance_documents/TOGGLE_REQUIRED_DOCUMENTS',
  APPROVE_DOC = '@@student/finance_documents/APPROVE_DOC',
  TOGGLE_DOC_SUCCESS = '@@student/finance_documents/TOGGLE_DOC_SUCCESS',
  TOGGLE_DOC_FAILURE = '@@student/finance_documents/TOGGLE_DOC_FAILURE',
  REJECT_DOC = '@@student/finance_documents/REJECT_DOC',
  RESCIND_REJECT_DOC = '@@student/finance_documents/RESCIND_REJECT_DOC',
  DELETE_DOC = '@@student/finance_documents/DELETE_DOC',
  CUSTOM_DOCUMENT_REQUEST = '@@student/finance_documents/CUSTOM_DOCUMENT_REQUEST',
  ACKNOWLEDGE_DOC = '@@student/finance_documents/ACKNOWLEDGE_DOC',
}
